import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import * as $ from "jquery";
class ConfigurationItemBillingSettingsTabDialog {
    Bao = Bao;
    AllServiceProvider;
    ServiceProviderId;
    ServiceProviderName;
    ServiceCategoryGroupName;
    ServiceCategoryGroupId;
    AllServiceGroup;
    AccountAssignmentTypeName;
    AccountAssignmentTypeId;
    AccountAssignment;
    AllAccountAssignment;
    CriteriaAccountAssignmentTypeName;
    CriteriaAccountAssignmentTypeId;
    CriteriaAccountAssignment;
    ExportEmptyAccountAssignments;
    constructor(data: any) {
        $.extend(this, data);
        this.SetupSubscriptions();
    }
    SetupSubscriptions() {
        this.AllServiceProvider.subscribe(() => {
            if (this.AllServiceProvider()) {
                this.ServiceProviderId(null);
                this.ServiceProviderName(null);
            }
        });
        this.AllServiceGroup.subscribe(() => {
            if (this.AllServiceGroup()) {
                this.ServiceCategoryGroupId(null);
                this.ServiceCategoryGroupName(null);
            }
        });
        this.AllAccountAssignment.subscribe(() => {
            if (this.AllAccountAssignment()) {
                this.AccountAssignmentTypeId(null);
                this.AccountAssignmentTypeName(null);
                this.AccountAssignment(null);
            }
        });
        this.ExportEmptyAccountAssignments.subscribe(() => {
            if (this.ExportEmptyAccountAssignments()) {
                this.CriteriaAccountAssignmentTypeId(null);
                this.CriteriaAccountAssignmentTypeName(null);
                this.CriteriaAccountAssignment(null);
            }
        });
    }
}
export default ConfigurationItemBillingSettingsTabDialog;